export default __webpack_public_path__ + "static/media/SortIcon.7fee2756.svg";